import { Flex } from "../Flex";
import { Icon } from "../Icon";

import cx from "classnames";

import "./ErrorCard.scss";

type ErrorCardProps = {
  variant: "default" | "border";
  error: string;
  title?: string;
  onClose?: () => void;
};

const ErrorCard = ({
  variant = "default",
  error,
  title,
  onClose,
}: ErrorCardProps) => {
  return (
    <Flex className={cx("ErrorCard", {
      "ErrorCard--Border": variant === "border",
    })} direction="row" align="center" gap="2">
      <Icon iconName="TriangleAlert" className="ErrorCard__Icon" size={24} />
      <div>
        <div className="ErrorCard__Title">{title}</div>
        {error && <div className="ErrorCard__Text">{error}</div>}
      </div>
      {onClose && (
        <button className="ErrorCard__Close" onClick={onClose}>
          <Icon iconName="X" size={16} />
        </button>
      )}
    </Flex>
  );
};

export { ErrorCard };
